import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { About } from '../components/sections/About';
import { Contact } from '../components/sections/Contact';
import { Facilities } from '../components/sections/Facilities';
import { Footer } from '../components/Footer';
import { Gallery } from '../components/sections/Gallery';
import { Hero } from '../components/sections/Hero';
import { Navigation } from '../components/Navigation';
import { Pricing } from '../components/sections/Pricing';
import { Services } from '../components/sections/Services';
import { Sponsors } from '../components/sections/Sponsors';
import { Trainers } from '../components/sections/Trainers';
import { WhatsAppCommunity } from '../components/WhatsAppCommunity';

const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // Wait for sections to mount, then smooth-scroll
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 80);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <Navigation />
      <Hero />
      <About />
      <Facilities />
      <Services />
      <Trainers />
      <Pricing />
      <Gallery />
      <Sponsors />
      <Contact />
      <WhatsAppCommunity />
      <Footer />
    </>
  );
};

export default HomePage;
